export default "__VITE_ASSET__DTjb9tcS__"